import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SettingService } from 'src/app/system-common/services/setting.service';
import * as Chart from 'chart.js';
import { DashboardService } from '../../services/dashboard.service';

@Component({
  selector: '',
  template: '',
})
export class IncomevsExpenseCommonChartHandler {
  chart: Chart;
  pieColorArray = [];
  @Input() chartVisible;
  @Output() closeChart = new EventEmitter<string>();
  frequencyArr = [
    this.settingService.getLabelValue('monthly'),
    this.settingService.getLabelValue('quarterly'),
    this.settingService.getLabelValue('yearly'),
  ];
  frequency = this.settingService.getLabelValue('yearly');
  selectedCalculationYears: string[] = [];
  selectedFrequencyTemp: string;
  selectedItemsTemp: any[] = [];

  selectedRegionTemp: any[] = [];
  selectedChannelTemp: any[] = [];
  selectedPartnerTemp: any[] = [];
  selectedProductTemp: any[] = [];

  regionOptions: any[] = [];
  channelOptions: any[] = [];
  partnerOptions: any[] = [];
  productOptions: any[] = [];
  showFilterModal: boolean = false;
  public calculationyears;
  private originalRectangleDraw;
  private userLoginData;

  // Partner Chanrt
  options;

  chartConfigs: { channel: string; year: string }[] = [];
  createdChartIds = new Set<string>();
  chartConfigsWithData: any[] = [];
  public selectedPartnerChannel: string = '';
  public agentPartnerWiseGraph: any;
  public selectedPartner;
  patnersData;
  public partnerChannels = [];
  public channelWiseYears;
  public partnerIds = [];
  isShowChart: Boolean;

  constructor(public service: DashboardService, public settingService: SettingService) {
    const dateStr = this.service.getDateFormatted(this.settingService.getSessionStorageValue('BatchDate'));
    const year = parseInt(dateStr.split('/')[2], 10);
    this.calculationyears = [String(year), String(year + 1)];
    this.originalRectangleDraw = Chart.elements.Rectangle.prototype.draw;

    if (sessionStorage.getItem('userLoginData') != undefined) {
      this.userLoginData = JSON.parse(sessionStorage.getItem('userLoginData'));
    }
  }

  ngOnInit() {
    this.loadBarChartDetails();
  }

  public loadBarChartDetails() {
    this.pieColorArray = this.service.getColor();
    setTimeout(() => {
      this.chartVisible == 'channel'
        ? this.channelWiseBarChartBrowser()
        : this.chartVisible == 'region'
        ? this.regionWiseChartBrowser()
        : this.chartVisible == 'product'
        ? this.productWiseBarChartBrowser()
        : this.chartVisible == 'partner'
        ? this.partnerWiseBarChartBrowser()
        : '';
    }, 10);
  }

  generateIncomeExpenseChart(params: {
    apiParam: string[];
    selectedKeys?: string[];
    frequency?: string;
    calculationYears?: any;
    chartType: 'bar' | 'horizontalBar';
    chartElementId: string;
    isHorizontal: boolean;
    chartInstanceKey: string;
    chartContext: 'region' | 'channel' | 'partner' | 'product';
  }) {
    this.frequency = params.frequency || this.frequency || 'QUARTERLY';

    if (this[params.chartInstanceKey]) {
      this[params.chartInstanceKey].destroy();
      this[params.chartInstanceKey] = null;
    }

    this.service
      .getIncomeExpenseData(params.apiParam, this.frequency, params.calculationYears)
      .subscribe((response) => {
        let resData;
        try {
          resData = JSON.parse(JSON.stringify(response));
        } catch {
          console.error('Failed to parse response data');
          return;
        }

        const rawData = resData?.data?.data?.[0] || {};
        const allYears = new Set<string>();
        const allQuarters = new Set<string>();
        const availableRegions = Object.keys(rawData);
        switch (params.chartContext) {
          case 'region':
            this.regionOptions = ['All', ...availableRegions];
            break;
          case 'channel':
            this.channelOptions = ['All', ...availableRegions];
            break;
          case 'partner':
            this.partnerOptions = ['All', ...availableRegions];
            break;
          case 'product':
            this.productOptions = ['All', ...availableRegions];
            break;
        }

        Object.values(rawData).forEach((channelData: any) => {
          Object.keys(channelData).forEach((year) => {
            allYears.add(year);
            const yearData = channelData[year];
            Object.keys(yearData?.income || {}).forEach((q) => allQuarters.add(q));
            Object.keys(yearData?.expense || {}).forEach((q) => allQuarters.add(q));
          });
        });

        const sortedYears = Array.from(allYears).sort();
        const sortedQuarters = Array.from(allQuarters).sort((a, b) =>
          a.localeCompare(b, undefined, { numeric: true })
        );

        const xMeta: { year: string; quarter: string }[] = [];
        const labels: string[] = [];
        const tooltipMeta: any = {};
        let labelIndex = 0;

        sortedYears.forEach((year) => {
          sortedQuarters.forEach((quarter) => {
            xMeta.push({ year, quarter });
            labels.push(`${quarter}`);
            tooltipMeta[labelIndex++] = { year, quarter };
          });
        });

        const datasets: any[] = [];
        const incomeColor = '#4e79a7';
        const expenseColor = '#f28e2b';

        const availableKeys = Object.keys(rawData);
        if (!params.selectedKeys || params.selectedKeys.includes('All') || params.selectedKeys.length == 0) {
          params.selectedKeys = availableKeys;
        } else if (!Array.isArray(params.selectedKeys)) {
          params.selectedKeys = [params.selectedKeys];
        }

        params.selectedKeys.forEach((key) => {
          const channelData = rawData[key];
          const incomeData: number[] = [];
          const expenseData: number[] = [];

          xMeta.forEach(({ year, quarter }) => {
            const yearData = channelData[year];
            const incomeVal = yearData?.income?.[quarter] ?? 0;
            const expenseVal = yearData?.expense?.[quarter] ?? 0;
            incomeData.push(incomeVal);
            expenseData.push(expenseVal);
          });

          datasets.push({
            label: key,
            channel: key,
            data: incomeData,
            backgroundColor: incomeColor,
            stack: key,
            datalabel: 'Income',
            barPercentage: incomeData.length > 2 ? 0.8 : 0.5,
            categoryPercentage: incomeData.length > 2 ? 0.6 : 0.3,
          });

          datasets.push({
            label: key,
            channel: key,
            data:
              params.chartElementId == 'region' || params.chartElementId == 'channel'
                ? expenseData.map((v) => -v)
                : expenseData,
            backgroundColor: expenseColor,
            stack: key,
            datalabel: 'Expense',
            barPercentage: expenseData.length > 2 ? 0.8 : 0.5,
            categoryPercentage: expenseData.length > 2 ? 0.6 : 0.3,
          });
        });

        const yearsInfo: { label: string; from: number; to: number }[] = [];
        let from = 0;
        let currentYear = xMeta[0].year;

        xMeta.forEach((meta, i) => {
          if (meta.year !== currentYear) {
            yearsInfo.push({ label: currentYear, from, to: i - 1 });
            from = i;
            currentYear = meta.year;
          }
        });
        yearsInfo.push({ label: currentYear, from, to: xMeta.length - 1 });

        const multiLabelPlugin = {
          beforeDraw(chart: any) {
            const ctx = chart.chart.ctx;
            const axis = params.isHorizontal ? chart.scales['y-axis-0'] : chart.scales['x-axis-0'];
            const chartArea = chart.chartArea;

            ctx.save();
            ctx.font = '12px sans-serif';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';

            yearsInfo.forEach((y) => {
              const start = axis.getPixelForTick(y.from);
              const end = axis.getPixelForTick(y.to);
              const center = (start + end) / 2;

              if (params.isHorizontal) {
                ctx.save();
                ctx.translate(chartArea.right + 45, center);
                ctx.rotate(Math.PI / 2);
                ctx.fillText(y.label, 0, 0);
                ctx.restore();
              } else {
                ctx.fillText(y.label, center, chartArea.top - 15);
              }

              if (yearsInfo.length > 1) {
                const separator = end + (axis.getPixelForTick(1) - axis.getPixelForTick(0)) / 2;
                if (
                  (params.isHorizontal && separator < chartArea.bottom) ||
                  (!params.isHorizontal && separator < chartArea.right)
                ) {
                  ctx.beginPath();
                  ctx.setLineDash([8, 4]);
                  if (params.isHorizontal) {
                    ctx.moveTo(chartArea.left, separator);
                    ctx.lineTo(chartArea.right, separator);
                  } else {
                    ctx.moveTo(separator, chartArea.top);
                    ctx.lineTo(separator, chartArea.bottom);
                  }
                  ctx.strokeStyle = '#888';
                  ctx.stroke();
                  ctx.setLineDash([]);
                }
              }
            });

            ctx.restore();
          },
        };

        this[params.chartInstanceKey] = new Chart(params.chartElementId, {
          type: params.chartType,
          data: { labels, datasets },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            layout: { padding: params.isHorizontal ? { right: 60 } : { top: 30 } },
            hover: { mode: 'nearest', intersect: false },
            plugins: {
              datalabels: {
                display: false,
              },
            },
            scales: params.isHorizontal
              ? {
                  xAxes: [
                    {
                      stacked: true,
                      ticks: {
                        display: this.frequency !== 'YEARLY',
                        beginAtZero: true,
                        callback: (val) => Math.abs(val).toLocaleString(),
                        fontColor: '#000000',
                        fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
                      },
                    },
                  ],
                  yAxes: [
                    {
                      stacked: true,
                      ticks: {
                        autoSkip: false,
                        fontColor: '#000000',
                        fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
                      },
                      gridLines: { display: false },
                    },
                  ],
                }
              : {
                  xAxes: [
                    {
                      stacked: true,
                      ticks: {
                        autoSkip: false,
                        display: this.frequency !== 'YEARLY',
                        fontColor: '#000000',
                        fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
                      },
                      gridLines: { display: false },
                    },
                  ],
                  yAxes: [
                    {
                      stacked: true,
                      ticks: {
                        beginAtZero: true,
                        callback: (val) => Math.abs(val).toLocaleString(),
                        fontColor: '#000000',
                        fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
                      },
                    },
                  ],
                },
            tooltips: {
              mode: 'nearest',
              intersect: true,
              bodyFontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
              callbacks: {
                title: (tooltipItems) => {
                  const meta = tooltipMeta[tooltipItems[0].index];
                  if (this.frequency == 'MONTHLY') return `Monthly: ${meta.quarter}, Year: ${meta.year}`;
                  if (this.frequency == 'QUARTERLY') return `Quarter: ${meta.quarter}, Year: ${meta.year}`;
                  if (this.frequency == 'YEARLY') return `Yearly: ${meta.quarter}, Year: ${meta.year}`;
                },
                label: function (tooltipItem, data) {
                  const ds = data.datasets[tooltipItem.datasetIndex];
                  const idx = tooltipItem.index;
                  const val = Number(ds.data[idx]) || 0;
                  const siblings = data.datasets.filter((d) => d.stack === ds.stack);
                  const totalAbs = siblings.reduce((s, d) => s + Math.abs(Number(d.data[idx]) || 0), 0);
                  const pct = totalAbs > 0 ? (Math.abs(val) / totalAbs) * 100 : 0;
                  const chLabel = ds.channel || ds.label || 'Unknown';
                  const type = ds.datalabel || (val >= 0 ? 'Income' : 'Expense');

                  let header = '';
                  if (params.chartContext === 'region') header = `Region: ${chLabel}`;
                  if (params.chartContext === 'channel') header = `Channel: ${chLabel}`;
                  if (params.chartContext === 'partner') header = `Partner: ${chLabel}`;
                  if (params.chartContext === 'product') header = `Product: ${chLabel}`;

                  return [header, `Type: ${type}`, `Value: ${Math.abs(val).toLocaleString()}(${pct.toFixed(2)}%)`];
                },
              },
            },
            legend: {
              display: true,
              position: 'bottom',
              labels: {
                fontColor: '#000000',
                fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
                generateLabels: function () {
                  return [
                    { text: 'Income', fillStyle: incomeColor, strokeStyle: incomeColor, lineWidth: 1 },
                    { text: 'Expense', fillStyle: expenseColor, strokeStyle: expenseColor, lineWidth: 1 },
                  ];
                },
              },
            },
          },
          plugins: [multiLabelPlugin],
        });
      });
  }

  regionWiseChartBrowser(selectedRegion?, regionFrequency?, calculationyears?) {
    this.chartVisible = 'region';
    this.isShowChart = false;
    setTimeout(() => {
      this.isShowChart = true;
      this.generateIncomeExpenseChart({
        apiParam: ['regioncd'],
        selectedKeys: selectedRegion,
        frequency: regionFrequency,
        calculationYears: calculationyears,
        chartType: 'horizontalBar',
        chartElementId: this.chartVisible,
        isHorizontal: true,
        chartInstanceKey: 'agentRegionWiseGraph',
        chartContext: this.chartVisible,
      });
    }, 0);
  }

  channelWiseBarChartBrowser(selectedChannel?, frequency?, calculationyears?) {
    this.chartVisible = 'channel';
    this.isShowChart = false;
    setTimeout(() => {
      this.isShowChart = true;
      this.generateIncomeExpenseChart({
        apiParam: ['channelcd'],
        selectedKeys: selectedChannel,
        frequency: frequency,
        calculationYears: calculationyears,
        chartType: 'bar',
        chartElementId: this.chartVisible,
        isHorizontal: false,
        chartInstanceKey: 'agentChannelWiseGraph',
        chartContext: this.chartVisible,
      });
    }, 0);
  }

  partnerWiseBarChartBrowser(selectedPartner?, partnerFrequency?: string, calculationyears?) {
    this.chartVisible = 'partner';
    this.isShowChart = false;
    setTimeout(() => {
      this.isShowChart = true;
      this.generateIncomeExpenseChart({
        apiParam: ['parentagencyid'],
        selectedKeys: selectedPartner,
        frequency: partnerFrequency || this.frequency || 'QUARTERLY',
        calculationYears: calculationyears,
        chartType: 'horizontalBar',
        chartElementId: this.chartVisible,
        isHorizontal: true,
        chartInstanceKey: 'agentPartnerWiseGraph',
        chartContext: this.chartVisible,
      });
    }, 0);
  }

  productWiseBarChartBrowser(selectedProduct?, productFrequency?: string, calculationyears?) {
    this.chartVisible = 'product';
    this.isShowChart = false;
    setTimeout(() => {
      this.isShowChart = true;
      this.generateIncomeExpenseChart({
        apiParam: ['productcd'],
        selectedKeys: selectedProduct,
        frequency: productFrequency || 'YEARLY',
        calculationYears: calculationyears,
        chartType: 'bar',
        chartElementId: this.chartVisible,
        isHorizontal: false,
        chartInstanceKey: 'agentProductWiseGraph',
        chartContext: this.chartVisible,
      });
    }, 0);
  }

  closeFilterModal(type) {
    $('#' + type + 'FilterModal').hide();
  }

  onOpenChartFilter(type: string) {
    this.chartVisible = type;

    switch (type) {
      case 'region':
        this.selectedRegionTemp = [...(this.selectedRegionTemp || [])];
        this.options = this.regionOptions || [];
        break;
      case 'channel':
        this.selectedChannelTemp = [...(this.selectedChannelTemp || [])];
        this.options = this.channelOptions || [];
        break;
      case 'partner':
        this.selectedPartnerTemp = [...(this.selectedPartnerTemp || [])];
        this.options = this.partnerOptions || [];
        break;
      case 'product':
        this.selectedProductTemp = [...(this.selectedProductTemp || [])];
        this.options = this.productOptions || [];
        break;
    }
    $('#' + type + 'FilterModal').toggle();
  }

  onDateRangeChange(event: any) {
    this.selectedCalculationYears = this.service.onDateRangeChange(event);
  }

  submitFilter(type: string) {
    this.closeFilterModal(type);
    switch (type) {
      case 'region':
        this.regionWiseChartBrowser(
          this.selectedRegionTemp,
          this.selectedFrequencyTemp,
          this.selectedCalculationYears
        );
        break;
      case 'channel':
        this.channelWiseBarChartBrowser(
          this.selectedChannelTemp,
          this.selectedFrequencyTemp,
          this.selectedCalculationYears
        );
        break;
      case 'partner':
        this.partnerWiseBarChartBrowser(
          this.selectedPartnerTemp,
          this.selectedFrequencyTemp,
          this.selectedCalculationYears
        );
        break;
      case 'product':
        this.productWiseBarChartBrowser(
          this.selectedProductTemp,
          this.selectedFrequencyTemp,
          this.selectedCalculationYears
        );
        break;
    }
  }

  onCloseClick() {
    this.closeChart.emit(this.chartVisible);
  }

  clearRegionData() {
    this.selectedRegionTemp = [];
    this.selectedItemsTemp = [];
    this.selectedFrequencyTemp = '';
    this.selectedCalculationYears = [];
    this.frequency = this.settingService.getLabelValue('yearly');

    $('#' + this.chartVisible + 'FilterModal').hide();
    const chartKey = 'agentRegionWiseGraph';
    if (this[chartKey]) {
      this[chartKey].destroy();
      this[chartKey] = null;
    }

    setTimeout(() => {
      this.regionWiseChartBrowser();
    }, 10);
  }

  clearChannelData() {
    this.selectedChannelTemp = [];
    this.selectedItemsTemp = [];
    this.selectedFrequencyTemp = '';
    this.selectedCalculationYears = [];
    this.frequency = this.settingService.getLabelValue('yearly');

    $('#' + this.chartVisible + 'FilterModal').hide();
    const chartKey = 'agentChannelWiseGraph';
    if (this[chartKey]) {
      this[chartKey].destroy();
      this[chartKey] = null;
    }

    setTimeout(() => {
      this.channelWiseBarChartBrowser();
    }, 10);
  }

  clearPartnerData() {
    this.selectedPartnerTemp = [];
    this.selectedItemsTemp = [];
    this.selectedFrequencyTemp = '';
    this.selectedCalculationYears = [];
    this.frequency = this.settingService.getLabelValue('yearly');

    $('#' + this.chartVisible + 'FilterModal').hide();
    const chartKey = 'agentPartnerWiseGraph';
    if (this[chartKey]) {
      this[chartKey].destroy();
      this[chartKey] = null;
    }

    setTimeout(() => {
      this.partnerWiseBarChartBrowser();
    }, 10);
  }

  clearProductData() {
    this.selectedProductTemp = [];
    this.selectedItemsTemp = [];
    this.selectedFrequencyTemp = '';
    this.selectedCalculationYears = [];
    this.frequency = this.settingService.getLabelValue('yearly');

    $('#' + this.chartVisible + 'FilterModal').hide();
    const chartKey = 'agentProductWiseGraph';
    if (this[chartKey]) {
      this[chartKey].destroy();
      this[chartKey] = null;
    }

    setTimeout(() => {
      this.productWiseBarChartBrowser();
    }, 10);
  }

  ngOnDestroy() {
    this.service.clear();
    Chart.elements.Rectangle.prototype.draw = this.originalRectangleDraw;
  }
}
